var LiveRaffles = LiveRaffles || function (ctx) {

    const longMomentDateTime = "dddd, D MMMM YYYY h:mm A";
    const drawDateFormat = "[Drawn: ]" + longMomentDateTime;
    const ticketFormat = "$0,0.00";
    const prizePoolFormat = "$0,0";

    ctx.maxItems = ctx.maxItems !== undefined && ctx.maxItems > 0 ? ctx.maxItems : 300;
    ctx.apiRoot = ctx.apiRoot || "https://api-carousel.prod.cloud.raffletix.com.au";
    ctx.apiPath = ctx.apiPath || "/carousel/popular";
    ctx.usePost = ctx.usePost || false;
    ctx.apiUrl = ctx.apiRoot + ctx.apiPath;
    ctx.debug = ctx.debug || false;
    ctx.noDefer = ctx.noDefer || false;
    ctx.pageSize = ctx.pageSize !== undefined && ctx.pageSize > 0 ? ctx.pageSize : 0;

    if (ctx.pageSize > 0) {
        ctx.maxItems = ctx.pageSize + 1; // add one to the max items to allow for the feature raffle
    }

    ctx.userAgent = ctx.userAgent || "chrome";

    const spacerImg = "https://assets.raffletix.com.au/home_asset/spacer.gif";

    const uiRoot = $(ctx.uiRoot);
    const evtRoot = uiRoot[0];

    const listItemTemplate = uiRoot.find(".lr-item-template").first().find(":first-child");

    const uiLoadingOuter = uiRoot.find(".lr-loading-outer");
    const uiRaffles = uiRoot.find(".page-raffles");
    const uiControlsOuter = uiRoot.find(".lr-controls-outer");
    const uiStates = uiRoot.find(".lr-states");
    const uiSortOrder = uiRoot.find(".lr-sort");

    const uiRaffleList = uiRoot.find(".lr-raffle-list");
    const uiRaffleListEmpty = uiRoot.find(".lr-raffle-list-empty");

    const uiLoadMore = uiRoot.find(".lr-raffle-load-more");
    const uiLoadMoreBtn = uiLoadMore.find(".lr-raffle-load-more-btn");


    const uiRaffleFeature = uiRoot.find(".lr-raffle-feature");
    const featureItemTemplate = uiRoot.find(".lr-feature-template").first().find(":first-child");

    const uiDebug = uiRoot.find(".lr-debug").first();

    const state = {
        raffles: [],
        sortFn: sortByPopular,
        filterFn: filterByState,
        stateFilters: [],
        searchText: "",
        observer: null,
        maxItems: ctx.maxItems
    };

    function debug(msg) {
        if (ctx.debug) {
            uiDebug.append($('<div/>').text(msg));
        }
    };

    function eventPublish(eventName, detail) {
        const event = new CustomEvent(eventName,
            {
                bubbles: false,
                detail: detail
            }
        );
        evtRoot.dispatchEvent(event);
    };

    function eventSubscribe(eventName, callback) {
        evtRoot.addEventListener(eventName, callback);
    };

    function bindImageLoader() {

        try {
            if (ctx.noDefer) {
                debug("skip lozad.js");
                return;
            }
            if ("lozad" in window) {
                debug("init lozad.js");
                state.observer = window["lozad"]();
            }

        } catch (ex) {
            debug("failed to init lozad.js: " + ex.message);
            if ("rtlog" in window) {
                window["rtlog"].stackTrace("liveRaffles.js: failed to init lozad.js: " + ex.message);
            }
        }
    };

    function registerPageEvents() {
        debug("registerPageEvents");

        uiStates.on("click", function (e) {
            e.preventDefault();

            let filterState = $(this);
            let addState = !filterState.hasClass("can-buy");
            let stateCd = filterState.data("selectstate");

            if (addState) {
                filterState.addClass("can-buy");
                state.stateFilters.push(stateCd);
            } else {
                filterState.removeClass("can-buy");
                state.stateFilters = state.stateFilters.filter(function (item) { return item !== stateCd; });
            }

            publishRenderData();
        });

        uiSortOrder.on("change", function (e) {
            e.preventDefault();
            state.sortFn = sortOptions[uiSortOrder.val()];
            publishRenderData();
        });

        eventSubscribe("raffleFeature", function (e) {
            renderFeatureRaffleUi(e.detail);
        });

        eventSubscribe("raffleList", function (e) {
            renderListUi(e.detail);
        });

        // filter based on the search box
        // search across the raffle name and organiser name and RaffleUSP 
        uiRoot.find(".lr-search").on("input", function (e) {
            e.preventDefault();
            state.searchText = $(this).val().toLowerCase().trim();

            publishRenderData();
        });

        if (ctx.pageSize > 0) {
            uiLoadMoreBtn.on("click", function (e) {
                e.preventDefault();
                state.maxItems += ctx.pageSize;
                publishRenderData();
            });
        }

    };

    function processsApiResponse (data) {

        if (data !== null) {
            uiLoadingOuter.addClass("hidden");
            uiRaffles.removeClass("hidden");

            // we only transform the data once
            state.raffles = transform(data);
            publishRenderData();
        }
    };


    function getPublicRaffles() {
        debug("getPublicRaffles");
        if (ctx.usePost) {
            $.ajax({
                url: ctx.apiUrl,
                cache: true,
                type: "POST",
                dataType: "json",
                contentType: "application/json",
                data: "",
                success: processsApiResponse,
                error: function (xhr, status, error) {
                    debug("failed to get raffles: " + error);
                    state.raffles = [];
                    publishRenderData();
                   
                }

            });
           
        }
        else {
            $.getJSON(ctx.apiUrl, processsApiResponse); 
        }
        
    };


    // transform raffle data
    function transform(data) {
        debug("transform");
        try {

            const utcNow = moment.utc();
            for (let i = 0; i < data.length; i++) {
                transformItem(data[i], i, utcNow);
            }
            return data;

        } catch (ex) {
            debug("failed transform: " + ex.message);
            if ("rtlog" in window) {
                window["rtlog"].stackTrace("liveRaffles.js: error running transformItem: " + ex.message);
            }
        }
    };


    function transformItem(item, idx, utcNow) {
        if (idx < 2) {
            debug("transformItem[" + idx + "]");
        }

        // this mutates the passed in item.
        // note: we enhance the data using CamelCase names as this is what the source data contains.
        // add extra data to support sorting
        item.MinsToDraw = moment.utc(item.DrawDt).diff(utcNow, "minutes");
        item.Rank = idx + 1;

        // flip state codes into a hash for quick filtering
        item.StateCds = {};
        item.ValidStates.forEach(function (value) {
            item.StateCds[value.Cd] = true;
        });

        if (idx < 2) {
            debug("transformItem[" + idx + "]:end");
        }
    };

    function renderItemTemplate(itemTemplate, item,  sref) {

        const template = itemTemplate.clone();

        // if no image leave the spacer image and no alt tag
        if (item.LogoColour.length > 0) {
            const altLogo = "Logo for " + item.OrganiserName + " for " + item.RaffleName;
            const logoImage = item.LogoColour + "?d=x30xdefaultx1";
            if (state.observer) {
                template.find(".lr-logo-img").addClass("lozad").attr({ "data-src": logoImage, "alt": altLogo });
            } else {
                template.find(".lr-logo-img").attr({ "src": logoImage, "alt": altLogo });
            }
        }

        // if no image leave the spacer image and no alt tag
        const bgImage = item.OpenGraphImageUrl.length > 0 ? item.OpenGraphImageUrl : item.BackgroundImageUrl;
        if (bgImage.length > 0) {
            const img = bgImage + "?d=600xdefaultx1";
            const imgStyle = "background-image: url(" + img + ");";
            const alt = "Raffle: " + item.RaffleName + " by " + item.OrganiserName;

            if (state.observer) {
                template.find(".lr-bg-img").addClass("lozad").attr("data-background-image", img);
                template.find(".lr-bg-img-sr").addClass("lozad").attr({ "data-src": img, "alt": alt });
            } else {
                template.find(".lr-bg-img").attr("style", imgStyle);
                template.find(".lr-bg-img-sr").attr({ "src": img, "alt": alt });
            }
        }

        template.find(".lr-tgt-url").attr("href", addSrefToCustomUrl(item, sref));
        template.find(".lr-raffle-name").text(item.RaffleName).attr("title", item.RaffleName);
        template.find(".lr-org-name").text(item.OrganiserName).attr("title", item.OrganiserName);
        template.find(".lr-draw").text(moment.utc(item.DrawDt).format(drawDateFormat));
        template.find(".lr-prize-pool").text(numeral(item.PrizePool).format(prizePoolFormat));
        template.find(".lr-min-ticket-price").text(numeral(item.BaseTicketPrice).format(ticketFormat));

        const uiValidStates = template.find(".lr-valid-states");

        item.ValidStates.forEach(function (value) {
            uiValidStates.find(".lr-" + value.Cd.toLowerCase()).addClass("can-buy");
        });
        
        return template[0];
    };

    function addSrefToCustomUrl(item, sref) {

        return item.CustomUrl +
            (item.CustomUrl.includes("?") ? "&" : "?") +
            "sref=" + sref;
    };

    // filtering and sorting, publishing events -------------------------

    function publishRenderData() {
        // we can replace the publish algorithm here
        applyFilterWithFeatureRaffle();
    };

    function applyFilterWithFeatureRaffle() {
        // this publish method chooses a feature raffle AND removes
        // the feature from the main listing.
        // as a result we publish both the feature and the main list.

        // the first slice creates a shallow copy of state.raffles
        // this ensures the sort does not change the of the original data.
        const filterFn = state.searchText.length > 0 ? filterByStateAndSearch : filterByState;

        const filteredRaffles = state.raffles
            .slice()
            .sort(state.sortFn)
            .filter(filterFn);

        const unRenderedRaffleCount = filteredRaffles.length - state.maxItems;
        const rafflesToRender = unRenderedRaffleCount > 0 ? filteredRaffles.slice(0, state.maxItems) : filteredRaffles;

        const featureRaffle = getFeatureRaffle(rafflesToRender);

        // note: we remove the featue from the main listing.
        const rafflesToRenderWithoutFeature = rafflesToRender.filter(function (item) { return item.RaffleRefCd !== featureRaffle.RaffleRefCd; });

        eventPublish("raffleFeature", featureRaffle);
        eventPublish("raffleList", { "raffles": rafflesToRenderWithoutFeature, "haveFeature": featureRaffle !== undefined, "haveUnrendered": unRenderedRaffleCount > 0 });

    };

    function getFeatureRaffle(raffles) {
        // choose the feature item
        // take the 4 (for filters that find a small number of raffles) plus the top quartile of the raffles to render
        // and randomly select one to feature
        // todo: replace this with a more sophisticated algorithm to select the feature item from a list of tagged candidates

        // note: if slice end > length of array, slice will return the full array.
        const featurePool = raffles.slice(0, 4 + Math.ceil(raffles.length / 4));

        const featureIndex = Math.floor(Math.random() * featurePool.length);
        return featurePool[featureIndex];
    };

    // rendering ui listings ---------

    // render the main list of raffles
    const listUiCache = {};
    function renderListUi(eventData) {
        debug("renderListUi");
        const rafflesToRender = eventData.raffles
        const haveFeature = eventData.haveFeature;
        const haveUnrendered = eventData.haveUnrendered;

        uiRaffleList.empty();

        let imgObserver = state.observer;

        debug("renderListUi.raffles[" + rafflesToRender.length + "]");
        if (rafflesToRender && rafflesToRender.length > 0) {

            debug("renderListUi:appendItems");
            uiRaffleListEmpty.addClass("hidden");
            uiRaffleList.removeClass("hidden");

            uiRaffleList.append(rafflesToRender.
                map(function (item) {
                    if (item.RaffleRefCd in listUiCache === false) {
                        listUiCache[item.RaffleRefCd] = renderItemTemplate(listItemTemplate, item, item.OrgRefCd + item.RaffleRefCd);
                    }
                    return listUiCache[item.RaffleRefCd];
                }));

            // refresh observation when image loader is in use.
            // we juse a local var as the bundler stuffs up the reference to the global state.observer
            if (imgObserver) {
                imgObserver.observe();
            }

            formatMargins();

            if (ctx.pageSize > 0) {
                if (haveUnrendered) {
                    uiLoadMore.removeClass("hidden");
                } else {
                    uiLoadMore.addClass("hidden");
                }
            }

        } else {
            if (!haveFeature) {
                uiRaffleListEmpty.removeClass("hidden");
            }
            if (ctx.pageSize > 0) {
                uiLoadMore.addClass("hidden");
            }
            
            uiRaffleList.addClass("hidden");
        }

    };


    // render the feature raffle
    const featureUiCache = {};
    function renderFeatureRaffleUi(featureRaffle) {

        debug("renderFeatureRaffleUi");
        uiRaffleFeature.empty();

        let imgObserver = state.observer;
        
        if (featureRaffle && featureRaffle.RaffleRefCd) {

            if (featureRaffle.RaffleRefCd in featureUiCache === false) {
                featureUiCache[featureRaffle.RaffleRefCd] = renderItemTemplate(featureItemTemplate, featureRaffle, featureRaffle.RaffleRefCd + featureRaffle.OrgRefCd);
            }

            uiRaffleFeature.append(featureUiCache[featureRaffle.RaffleRefCd]);
            uiRaffleFeature.removeClass("hidden");

            if (imgObserver) {
                imgObserver.observe();
            }

            formatMargins();

        } else {
            uiRaffleFeature.addClass("hidden");
        }

    };

    function formatMargins() {

        var widthDiv = uiRaffleList.offsetWidth;

        var widthSpace = widthDiv * 0.5 * 0.02;
        uiControlsOuter.css({
            "margin-right": widthSpace + "px",
            "margin-left": widthSpace + "px"
        });
    };


    // sorting -------------------------

    function sortByPopular(a, b) {
        return a.Rank - b.Rank;
    };

    function sortByDrawDate(a, b) {
        return a.MinsToDraw - b.MinsToDraw;
    };

    function sortByPrizePool(a, b) {
        // sort descending order -> b - a
        return b.PrizePool - a.PrizePool;
    };

    function sortByTicketPrice(a, b) {
        return a.BaseTicketPrice - b.BaseTicketPrice;
    };

    const sortOptions = {
        "MostPopular": sortByPopular,
        "DrawDate": sortByDrawDate,
        "PrizePool": sortByPrizePool,
        "TicketPrice": sortByTicketPrice,
    };


    // filtering -------------------------

    function filterByStateAndSearch(item) {
        
        if ( filterByState(item) ) {

            return item.RaffleName.toLowerCase().includes(state.searchText) || item.OrganiserName.toLowerCase().includes(state.searchText) || item.RaffleUSP.toLowerCase().includes(state.searchText);
        }

        return false;
    }


    function filterByState(item) {

        if (state.stateFilters.length > 0) {
            return state.stateFilters.every(function (value) {
                return item.StateCds[value];
            });
        }

        return true;
    };

    return {
        init: function () {
            try {
                debug(ctx.userAgent);
                debug("init");
                bindImageLoader();
                registerPageEvents();
                getPublicRaffles();
            } catch (ex) {
                debug("failed to init: " + ex.message);
                if ("rtlog" in window) {
                    window["rtlog"].stackTrace("liveRaffles.js: failed to init lozad.js: " + ex.message);
                }
            }
        }
    };

};

var apiRoot = document.currentScript.getAttribute("data-apiRoot");
window.addEventListener("load", function () {
  
  function doLoad() {
    LiveRaffles({
      uiRoot: ".lr-root",
      apiRoot: apiRoot,
      apiPath: "/api/publicdata/activerafflesummary",
      usePost: true,
      debug: false,
      noDefer: false,
      userAgent: "tba",
      pageSize: 30
    }).init();
  };

  doLoad();
  if ("Blazor" in window) {
    Blazor.addEventListener('enhancedload', doLoad);
  }
});
